var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.821652 0.821407C1.13421 0.508845 1.55814 0.333252 2.00016 0.333252C2.44219 0.333252 2.86611 0.508845 3.17867 0.821407C3.49123 1.13397 3.66683 1.55789 3.66683 1.99992C3.66683 2.44195 3.49123 2.86587 3.17867 3.17843C2.86611 3.49099 2.44219 3.66659 2.00016 3.66659C1.55814 3.66659 1.13421 3.49099 0.821652 3.17843C0.509091 2.86587 0.333496 2.44195 0.333496 1.99992C0.333496 1.55789 0.509091 1.13397 0.821652 0.821407ZM8.82165 0.821407C9.13421 0.508844 9.55814 0.333252 10.0002 0.333252C10.4422 0.333252 10.8661 0.508844 11.1787 0.821407C11.4912 1.13397 11.6668 1.55789 11.6668 1.99992C11.6668 2.44194 11.4912 2.86587 11.1787 3.17843C10.8661 3.49099 10.4422 3.66659 10.0002 3.66659C9.55814 3.66659 9.13421 3.49099 8.82165 3.17843C8.50909 2.86587 8.3335 2.44194 8.3335 1.99992C8.3335 1.55789 8.50909 1.13397 8.82165 0.821407ZM16.8217 0.821407C17.1342 0.508844 17.5581 0.333252 18.0002 0.333252C18.4422 0.333252 18.8661 0.508844 19.1787 0.821407C19.4912 1.13397 19.6668 1.5579 19.6668 1.99992C19.6668 2.44194 19.4912 2.86587 19.1787 3.17843C18.8661 3.49099 18.4422 3.66659 18.0002 3.66659C17.5581 3.66659 17.1342 3.49099 16.8217 3.17843C16.5091 2.86587 16.3335 2.44195 16.3335 1.99992C16.3335 1.55789 16.5091 1.13397 16.8217 0.821407Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptDots);
export default __webpack_public_path__ + "static/media/opt-dots.cca3fe64e677ce623b73dd4735cdcaa9.svg";
export { ForwardRef as ReactComponent };